import { FormattedMessage } from 'react-intl';

import { useModals } from 'context';

import { Modal } from 'components';

import { AssessmentAnswersProps } from './types';

import * as S from './styles';

const AssessmentAnswers: React.FC<AssessmentAnswersProps> = ({
  modalKey,
  props,
  isOpen,
}) => {
  const { closeModal } = useModals();

  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => closeModal(modalKey)}
      data-testid="answersModal"
    >
      <S.ModalTitle data-testid="assessmentModalTitle">
        {props.title}
      </S.ModalTitle>
      <S.Container data-testid="assessmentContainer">
        <S.AnswerContent
          data-testid="iframeWindow"
          title="Assessments Answers"
          src={`${props.url}`}
        />
        <S.ModalButton
          data-testid="returnAnswersButton"
          onClick={() => closeModal(modalKey)}
        >
          <FormattedMessage id="ACTIVITIES.MODAL.BUTTON.BACK" />
        </S.ModalButton>
      </S.Container>
    </Modal>
  );
};

export default AssessmentAnswers;
